import React, { Component } from 'react';
import HsvToRgb from './helpers/HsvToRgb';
import { RgbHexToHsv } from './helpers/RgbToHsv';
import RgbHexToRgba from './helpers/RgbHexToRgba';
import ValueWithinConstraints from './helpers/ValueWithinConstraints';
import { getTranslation } from '../../assets/creator/translations';
import Checkerboard from './Checkerboard.svg';
import releaseSettings from '../../config/releaseSettings';
import { getLastUsedColorsFromFile } from '../../assets/creator/themes';
import { RgbaToHex } from './helpers/RgbaToHex';

class ColorPickerPalette extends Component {
    constructor(props) {
        super(props);
        this.pickerRef = React.createRef();
        this.tooltipRef = React.createRef();
        const { h, s, v } = RgbHexToHsv(this.props.color);
        this.state = {
            hue: h,
            saturation: s,
            brightness: v,
            rgb: this.props.color,
            isDragging: false,
            isDraggingAlpha: false,
            tooltipOffset: {},
            alpha: this.props.alpha,
            lastUsedColors: this.getLastUsedColors()
        }
        this.canvasPickerSize = 170;
        this.canvasWidth = 150;
        this.drawXStart = 0;
        this.drawYStart = 0;
        this.drawYStartScroll = 185;
        this.huePickerHeight = 8;
    }

    getLastUsedColors = () => {
        let colorsArray = [];
        if(localStorage.getItem('lastUsedColorsB2B') != null) {
            colorsArray = localStorage.getItem('lastUsedColorsB2B').split('|');
        } else {
            localStorage.setItem('lastUsedColorsB2B', getLastUsedColorsFromFile('Default'));
            setTimeout(function() {
                colorsArray = localStorage.getItem('lastUsedColorsB2B').split('|');
            });
        }

        if(colorsArray.length > 12) {
            colorsArray.splice(12,colorsArray.length-1);
        }

        return colorsArray;
    }

    clearCanvas() {
        const context = this.pickerRef.current.getContext("2d");
        const tmp = context.fillStyle;
        context.fillStyle = "#fff";
        context.fillRect(0, 0, context.canvas.width, context.canvas.height);
        context.fillStyle = tmp;
    }

    drawElements() {
        const ctx = this.pickerRef.current.getContext("2d");
        //remember line width
        const lw = ctx.lineWidth;
        //set linewidth
        ctx.lineWidth = 1.5;

        /* draw circle in hue area */
        // ctx.globalCompositeOperation = "multiply";
        //hue = x / this.canvasPickerSize * 360
        // x = hue/360*this.canvasPickerSize;
        const hueX = Math.round(this.state.hue / 330 * this.canvasPickerSize + this.drawXStart);
        const hueY = this.huePickerHeight / 2 + this.drawYStartScroll;
        const hueRadius = 3.5;
        ctx.beginPath();
        ctx.strokeStyle = "#fff";
        ctx.fillStyle = "rgba(0,0,0,0)";
        ctx.arc(hueX, hueY, hueRadius, 0, 2 * Math.PI, false)
        ctx.stroke();
        /* draw circle in saturation/brightness area */
        //sat = x / this.canvasPickerSize * 100
        //sat*canvaspickerSize/100
        const sbX = this.state.saturation * this.canvasPickerSize / 100 + this.drawXStart;
        //brightness = 100 - y / this.canvasPickerSize * 100
        //(100-brighness)*this.canvasPickerSize/100
        const sbY = 8 + (100 - this.state.brightness) * this.canvasPickerSize / 100 + this.drawYStart;
        ctx.beginPath();
        ctx.strokeStyle = "#fff";
        ctx.fillStyle = "rgba(0,0,0,0)";
        ctx.arc(sbX, sbY, 6.5, 0, 2 * Math.PI, false);
        ctx.stroke();
        ctx.fill();
        ctx.lineWidth = lw;

    }
    calculateRgb = (updateLastUsedColor = false) => {
        const h = this.state.hue / 360;
        const s = this.state.saturation / 100;
        const v = this.state.brightness / 100;
        const rgb = HsvToRgb(h, s, v);
        rgb.r = rgb.r.toString(16)
        rgb.g = rgb.g.toString(16)
        rgb.b = rgb.b.toString(16)
        if (rgb.r.length < 2) {
            rgb.r = '0'.concat(rgb.r);
        }
        if (rgb.g.length < 2) {
            rgb.g = '0'.concat(rgb.g);
        }
        if (rgb.b.length < 2) {
            rgb.b = '0'.concat(rgb.b);
        }
        const rgbHex = '#' + rgb.r + rgb.g + rgb.b;
        this.setState({ rgb: rgbHex })
        if (typeof this.props.onChange === "function") {
            this.props.onChange(rgbHex, this.state.alpha)
        }
        if(updateLastUsedColor) {
            return rgbHex;
        }
    }

    roundRect = (
        ctx,
        x,
        y,
        width,
        height,
        radius = 4,
        fill = true,
        stroke = true
      ) => {
        if (typeof radius === 'number') {
          radius = {tl: radius, tr: radius, br: radius, bl: radius};
        } else {
          radius = {...{tl: 0, tr: 0, br: 0, bl: 0}, ...radius};
        }
        ctx.beginPath();
        ctx.moveTo(x + radius.tl, y);
        ctx.lineTo(x + width - radius.tr, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
        ctx.lineTo(x + width, y + height - radius.br);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
        ctx.lineTo(x + radius.bl, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
        ctx.lineTo(x, y + radius.tl);
        ctx.quadraticCurveTo(x, y, x + radius.tl, y);
        ctx.closePath();
        if (fill) {
          ctx.fill();
        }
        if (stroke) {
          ctx.stroke();
        }
      }

    drawGradient = () => {
        this.drawHueGradient();
        this.drawSaturationBrightnessGradient();

    }
    drawHueGradient = () => {
        const ctx = this.pickerRef.current.getContext("2d");
        const grd = ctx.createLinearGradient(0, 0, 200, 0);
        grd.addColorStop(0, "#f00");
        grd.addColorStop(1 / 6, "#fe0");
        grd.addColorStop(2 / 6, "#5fff42");
        grd.addColorStop(3 / 6, "#00f9ff");
        grd.addColorStop(4 / 6, "#2b00ff");
        grd.addColorStop(5 / 6, "#b400ff");
        grd.addColorStop(1, "#b400ff");
        ctx.fillStyle = grd;
        ctx.strokeStyle = "#fff";

        this.roundRect(ctx, this.drawXStart, this.drawYStartScroll, this.canvasPickerSize, this.huePickerHeight)
    }
    drawSaturationBrightnessGradient = () => {
        const ctx = this.pickerRef.current.getContext("2d");
        //translate the offsets so it's easier to draw
        ctx.translate(this.drawXStart, this.huePickerHeight + this.drawYStart);
        //create up-down brigthness gradient
        const gradientBrightness = ctx.createLinearGradient(0, 0, 0, 190);
        gradientBrightness.addColorStop(0, "#fff");
        gradientBrightness.addColorStop(1, "#000");

        //create saturation gradient based on hue
        const gradientSaturation = ctx.createLinearGradient(0, 0, this.canvasWidth, 0);
        gradientSaturation.addColorStop(0, `hsla(${this.state.hue},100%,90%,0)`)
        gradientSaturation.addColorStop(1, `hsla(${this.state.hue},100%,50%,1)`)

        //draw rectangle with brightness gradient
        ctx.fillStyle = gradientBrightness;
        ctx.fillRect(0, 0, this.canvasPickerSize, this.canvasPickerSize);

        //tell canvas to draw next with saturation gradient
        ctx.fillStyle = gradientSaturation;
        //tell canvas that we don't want to draw over the gradient, but the result should be multiplied
        //resulting in a nice saturation-brightness gradient
        ctx.globalCompositeOperation = "multiply";
        ctx.fillRect(0, 0, this.canvasPickerSize, this.canvasPickerSize);
        //tell the canvas to draw over (set the default value back)
        ctx.globalCompositeOperation = "source-over";
        //revert translation from the beginning
        ctx.translate(-this.drawXStart, -this.huePickerHeight - this.drawYStart);

    }
    /**
     * @param {React.MouseEvent} e 
     */
    handleMouseDownCapture = (e) => {
        e.persist();
        const natEv = e.nativeEvent;
        const y = natEv.offsetY;
        if (y >= this.drawYStartScroll + this.huePickerHeight-15) {
            this.setState({ isDraggingHue: true }, () => this.handleMouseMove(e));
        } else {
            this.setState({ isDraggingLS: true }, () => this.handleMouseMove(e));
        }
        window.addEventListener("mouseup", this.handleMouseUp)

    }

    handleMouseMove = (e) => {
        e.preventDefault();
        
        /* kwadrat */
        if (this.state.isDraggingLS) {
             this.updateLS(e); 
            
        };

        /* pasek */
        if (this.state.isDraggingHue) {
            this.updateHue(e);
            
        };
    }
    /**
     * @param {React.MouseEvent} e 
     */
    updateLS = (e) => {
        const natEv = e.nativeEvent;

        const x = natEv.offsetX - this.drawXStart;
        //subtract picker height
        const y = natEv.offsetY - this.huePickerHeight - this.drawYStart;
        //make sure the value is non-negative
        const saturation = Math.round(x / this.canvasPickerSize * 100);
        const brightness = Math.round(100 - y / this.canvasPickerSize * 100);
        this.setState({
            saturation: ValueWithinConstraints(saturation, 0, 100),
            brightness: ValueWithinConstraints(brightness, 0, 100)
        });
    }

    updateHue = (e) => {
        const natEv = e.nativeEvent;
        const x = natEv.offsetX ;
        //compute hue
        const hue = Math.floor(x / this.canvasPickerSize * 330);
        //set in state
        this.setState({ hue: ValueWithinConstraints(hue, 0, 330) })
    }

    handleMouseUp = () => {
        this.setState({ isDraggingHue: false, isDraggingLS: false })
        window.removeEventListener("mouseup", this.handleMouseUp)
        let lastColor = this.calculateRgb(true);
        lastColor = RgbHexToRgba(lastColor, this.state.alpha);
        this.updateLastUsedColors(lastColor);
    }

    updateLastUsedColors = (newColor) => {
        if(localStorage.getItem('lastUsedColorsB2B') != null) {
            const lastUsedColors = localStorage.getItem('lastUsedColorsB2B').split('|');
            let isDuplicated = false;
            let duplicatedIndex = 0;
    
            for (let i = 0; i < lastUsedColors.length; i++) {
                if (newColor === lastUsedColors[i]) {
                    isDuplicated = true;
                    duplicatedIndex = i;
                    break;
                }
            }
    
            if (isDuplicated) {
                lastUsedColors.splice(duplicatedIndex,1);
            }
    
            lastUsedColors.unshift(newColor);
            lastUsedColors.splice(12,lastUsedColors.length -1);
            localStorage.removeItem('lastUsedColorsB2B');
            localStorage.setItem('lastUsedColorsB2B', lastUsedColors.join('|'));
            this.setState({lastUsedColors: this.getLastUsedColors()});
        } else {
            this.setState({lastUsedColors: this.getLastUsedColors()});
        }
    }
    
    getTooltipOffset = () => {
        //if we have nothing to position relative to, default to top left corner
        if (!this.props.buttonRef.current || !this.tooltipRef.current) {
            return { left: 0, top: 0 };
        }
        const btnRef = this.props.buttonRef.current;
        const containerRef = this.props.containerRef && this.props.containerRef.current;
        const tooltipRef = this.tooltipRef.current;

        const heightWithBottomMargin = tooltipRef.clientHeight + 5;

        let top = btnRef.offsetTop + btnRef.clientHeight - window.scrollY;
        const left = btnRef.offsetLeft + btnRef.clientWidth;
        //if element is in scrollable container and a ref to it is passed
        if (containerRef) {
            //we account for the pixel scrolled amount
            top -= containerRef.scrollTop;
        }

        // Calculate final top position with constraints
        let finalTop;
        if (top < 5) {
            finalTop = 5;
        } else if (top + heightWithBottomMargin > window.innerHeight) {
            finalTop = window.innerHeight - heightWithBottomMargin;
        } else {
            finalTop = top;
        }

        this.setState({
            tooltipOffset: {
                left: left,
                top: finalTop,
            }
        })
    }

    onScrollEventListener = () => {
        this.getTooltipOffset();
    }

    checkForClickOutside = (e) => {
        if (this.tooltipRef.current.contains(e.target)) { ; }
        else if (this.props.buttonRef.current.contains(e.target)) { ; }
        else {
            this.props.onCancel();
        }
    }

    componentDidMount = () => {
        //add scroll event listener to body and scrollableContainer(if exists) in order to reposition the tooltip on scroll
        if (this.props.containerRef) {
            this.props.containerRef.current.addEventListener("scroll", this.onScrollEventListener);
        }
        document.addEventListener("scroll", this.onScrollEventListener);
        //call it once to position it right on mount
        this.onScrollEventListener();
        //add event listener to check if there was a click performed outside of the picker
        document.addEventListener('mousedown', this.checkForClickOutside);
        //do canvas stuff
        this.clearCanvas();
        this.drawGradient();
        this.drawElements();

        this.updateLastUsedColors(RgbHexToRgba(this.props.color, this.props.alpha));
    }

    componentWillUnmount = () => {
        //remove scroll event listeners
        if (this.props.containerRef?.current) {
            this.props.containerRef.current.removeEventListener("scroll", this.onScrollEventListener);
        }
        document.removeEventListener("scroll", this.onScrollEventListener);
        document.removeEventListener('mousedown', this.checkForClickOutside);


        const inputColor = document.getElementById('colorInput');
        const inputColorValue = inputColor.value;
        const inputAlphaValue = document.getElementById('alphaInput').getAttribute('value');

        if(this.checkIfHex(inputColorValue)) {
            this.updateLastUsedColors(RgbHexToRgba(inputColorValue, inputAlphaValue));
        }
    }

    componentDidUpdate() {
        this.clearCanvas();
        this.drawGradient();
        this.drawElements();
        this.calculateRgb();
        this.props.onConfirm()
    }
    shouldComponentUpdate = (_nextProps, nextState) => {
        const colorChanged =
            nextState.hue !== this.state.hue ||
            nextState.saturation !== this.state.saturation ||
            nextState.brightness !== this.state.brightness;

        const rgbOrAlphaChanged =
            nextState.rgb !== this.state.rgb ||
            nextState.alpha !== this.state.alpha;

        const tooltipChanged =
            nextState.tooltipOffset.top !== this.state.tooltipOffset.top ||
            nextState.tooltipOffset.left !== this.state.tooltipOffset.left;

        const lastUsedColorsChanged =
            nextState.lastUsedColors !== this.state.lastUsedColors;

        return (
            colorChanged ||
            rgbOrAlphaChanged ||
            tooltipChanged ||
            lastUsedColorsChanged
        );
    };

    alphaPicker = () => {
        return <div className="color-palette__area-alpha-picker"
         style={{
            width: this.canvasPickerSize,
            height: this.huePickerHeight,
            borderRadius: '4px',
            background: "left top/contain white",
            backgroundImage: `linear-gradient(to right, ${this.state.rgb}, ${RgbHexToRgba(this.state.rgb + "00")}), url(${Checkerboard})`
        }}>
        <div
            className="color-palette__alpha-picker"
            style={{
                width: this.canvasPickerSize,
                height: this.huePickerHeight,
            }}
            onMouseDownCapture={this.onAlphaPickerDownCapture}
            onMouseMove={this.onAlphaPickerMove}
                   
        >   
            <div 
                style={{
                    border: "solid 1.5px #fff",
                    borderRadius: '4px',
                    boxSizing: "border-box",
                    position: "absolute",
                    zIndex: 1,
                    top: '0',
                    // marginTop: '1px',
                    height: '8px',
                    width: '8px',
                    transform: "translate(-50%, 0)",
                    left: (Math.round((1 - this.state.alpha) * 1000) / 10) + "%",
                    pointerEvents: "none"

                }}
            ></div>
        </div>
        </div>
    }

    onAlphaPickerDownCapture = (e) => {
        e.persist();
        this.setState({ isDraggingAlpha: true }, () => this.onAlphaPickerMove(e));
        window.addEventListener("mouseup", this.onAlphaPickerUp);

        this.onAlphaPickerMove(e);
    }

    onAlphaPickerUp = () => {
        this.setState({ isDraggingAlpha: false });
        window.removeEventListener("mouseup", this.onAlphaPickerUp);
        let lastColor = this.calculateRgb(true);
        lastColor = RgbHexToRgba(lastColor, this.state.alpha);
        this.updateLastUsedColors(lastColor);
    }

    /**
     * @param {React.MouseEvent} e
     */
     onAlphaPickerMove = (e) => {
        if (!this.state.isDraggingAlpha) {
            return;
        }

        const x = e.nativeEvent.offsetX;

        let alpha = 1 - x / this.canvasPickerSize;
        //snap edges
        if (alpha < 0.05) {
            alpha = 0;
        }
        if (alpha > 0.95) {
            alpha = 1;
        }
        this.setState({ alpha: alpha });
    }

    /**
     * @param {React.MouseEvent} e
     */
    setColorFromLastUsedColors = (e) => {
        e.preventDefault();
        const index = e.currentTarget.dataset.index;
        this.setState((prevState) => {
            const newColor = RgbaToHex(prevState.lastUsedColors[index]); 
            return {rgb: newColor[0], alpha: parseFloat(newColor[1])};
        }, () => {
            const newColor = RgbaToHex(this.state.lastUsedColors[index]);
            this.props.onConfirm(newColor[0], parseFloat(newColor[1]));
            this.props.toggleRef();
        });
    }

    showLastUsedColors = (i) => {
        return (
            <div
                ref={this.pickerRef}
                className={"btn-group__btn-color " + i}
                data-index={i}
                onClick={this.setColorFromLastUsedColors}
                style={{ 
                    background: "left top/contain white",
                    backgroundImage: `linear-gradient(to right, ${this.state.lastUsedColors[i]}, ${this.state.lastUsedColors[i]}), url(${Checkerboard})`,
                    }}
                >
            </div>
        )
    }

    checkIfHex = (hex) => {
        let isHex = false;
        const hexRegex = /[0-9a-fA-F]+/;
        if(hex[0] === '#' && hex.length === 7) {
            for(let i=1;i<hex.length;i++) { 
                if(hex[i].match(hexRegex) === null) {
                    return false;
                }
            }
            isHex = true;
        }
        return isHex;
    }

    render = () => (
        <div className="color-palette" style={this.state.tooltipOffset} ref={this.tooltipRef} >
            <div className="last-used">
                <span className='last-used__text1'>{getTranslation("recentlyUsed")}</span>
                <div className="btn-group">
                    {this.showLastUsedColors(0)}
                    {this.showLastUsedColors(6)}
                    {this.showLastUsedColors(1)}
                    {this.showLastUsedColors(7)}
                    {this.showLastUsedColors(2)}
                    {this.showLastUsedColors(8)}
                    {this.showLastUsedColors(3)}
                    {this.showLastUsedColors(9)}
                    {this.showLastUsedColors(4)}
                    {this.showLastUsedColors(10)}
                    {this.showLastUsedColors(5)}
                    {this.showLastUsedColors(11)}
                </div>
                <span className="last-used__text2">{getTranslation("own")}</span>
            </div>
            
            <canvas
                ref={this.pickerRef}
                onMouseDownCapture={this.handleMouseDownCapture}
                onMouseMove={this.handleMouseMove}
                onMouseUp={this.handleMouseUp}
                onMouseLeave={this.handleMouseLeave}
                width="170px"
                height="200px"
                className="color-palette__canvas"
                id="colorPalette__canvas"
            />
            {!releaseSettings.hideOpacityPicker && this.alphaPicker()}
            <div className="color-palette__options">
                <div className="color-palette__values">
                    <span className="span-color"><input type="text" className="colorInput" id="colorInput" onBlur={this.props.onBlur} defaultValue={this.state.rgb} maxLength="7"></input>Hex</span>
                     {!releaseSettings.hideOpacityPicker && <span className="span-alpha"><input type="text" className="alphaInput" id="alphaInput"defaultValue={this.state.alpha} maxLength="3"></input>Opacity</span> }
                </div>
               
            </div>
        </div>
    ) 
}

export default ColorPickerPalette;